import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <div className="text-center py-16">
      <h1 className="text-6xl font-serif mb-4">404</h1>
      <h2 className="text-xl font-serif mb-6">Page Not Found</h2>
      <p className="text-[#8f8fa3] mb-8">
        The page you're looking for doesn't exist or has been moved.
      </p>
      <Link 
        to="/" 
        className="inline-block px-6 py-2 bg-white text-[#050505] rounded hover:bg-[#c5c5d0] transition-colors"
      >
        Go home
      </Link>
    </div>
  );
};

export default NotFound;
